import { Spacing } from '@persona-id/design-tokens';
import { AiFillIcon, LoaderIcon, RotateCwIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import { rotate } from 'design-system/variables/keyframes';

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.color.primary.brand100};
  padding: ${Spacing[2]} ${Spacing[4]};
  border-radius: ${Spacing[1]};
  height: 40px;
  margin-bottom: ${Spacing[4]};
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacing[2]};
`;

const IconWrapper = styled.div`
  color: ${({ theme }) => theme.color.primary.brand800};
  display: flex;
`;

const Message = styled.span`
  margin: 0;
  font-size: ${Spacing[3]};
  color: ${({ theme }) => theme.color.text.primary};
  line-height: 1.4;
`;

const UseLink = styled.a`
  color: ${({ theme }) => theme.color.primary.brand800};
  text-decoration: underline;
  font-size: ${Spacing[3]};
  cursor: pointer;
`;

const Spinner = styled(LoaderIcon)`
  width: ${Spacing[4]};
  height: ${Spacing[3]};
  color: ${({ theme }) => theme.color.primary.brand700};
  animation: ${rotate} 1s linear infinite;
`;

interface SmartMappingBannerProps {
  message: string;
  loadingMessage: string;
  errorMessage: string;
  onUseClick: () => void;
  isLoading: boolean;
  isError: boolean;
}

const SmartMappingBanner: React.FC<SmartMappingBannerProps> = ({
  message,
  loadingMessage,
  errorMessage,
  onUseClick,
  isLoading,
  isError,
}) => {
  return (
    <BannerContainer>
      <ContentWrapper>
        <IconWrapper>
          <AiFillIcon />
        </IconWrapper>
        <Message>{isLoading ? loadingMessage : isError ? errorMessage : message}</Message>
      </ContentWrapper>
      {isLoading ? (
        <Spinner />
      ) : isError ? (
        <IconWrapper id='smart-mapping-banner__reload-button' onClick={onUseClick}>
          <RotateCwIcon />
        </IconWrapper>
      ) : (
        <UseLink id='smart-mapping-banner__use-button' onClick={onUseClick}>
          Use
        </UseLink>
      )}
    </BannerContainer>
  );
};

export default SmartMappingBanner;
